exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link_dialog .goods_link[data-v-108d5966]{width:300px;height:40px;padding:8px;border:1px solid #eeeeee}.link_dialog .add-div[data-v-108d5966]{width:300px;margin-bottom:0;margin-top:5px}\n", ""]);

// exports
